import React from "react";
import { useInventoryTransfer } from "../../../../../hooks/inventory/useInventoryTransfer";
import FormModal from "../../../../Modals/FormModal";
import TransferInfoSection from "../TransferDetail/Sections/TransferInfoSection";
import TransferBranchesSection from "../TransferDetail/Sections/TransferBranchesSection";
import TransferFlowSection from "../TransferDetail/Sections/TransferFlowSection";
import AuditSection from "../TransferDetail/Sections/AuditSection";

const InventoryTransferCancelModal: React.FC = () => {
  const {
    handlerCancel,
    showCancelModal,
    form,
    closeCancelModal,
  } = useInventoryTransfer();

  if (!form) return null;

  const canCancel =
    form.status === "REQUESTED" || form.status === "APPROVED";

  return (
    <FormModal
      isOpen={showCancelModal}
      onClose={closeCancelModal}
      title="Cancelar Traslado"
      maxWidth="max-w-4xl"
      zIndex='front'
    >
      <div className="space-y-8 px-2 py-4">
        <TransferInfoSection
          details={form.details}
          reason={form.reason}
          status={form.status}
        />

        <TransferBranchesSection
          origin={form.originBranchName}
          destination={form.destinationBranchName}
        />

        <TransferFlowSection detail={form} />

        <AuditSection detail={form} />
      </div>

      {/* ------------------------------------------------------------ */}
      {/* BOTONES */}
      {/* ------------------------------------------------------------ */}
      <div className="mt-6 flex justify-end gap-3">

        {/* CERRAR */}
        <button
          type="button"
          onClick={closeCancelModal}
          className="inline-flex rounded bg-[#637381] px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>

        {/* CANCELAR TRASLADO */}
        {canCancel && (
          <button
            type="button"
            onClick={() => handlerCancel(form.id)}
            className="inline-flex rounded bg-[#F9C107] px-6 py-2 text-sm font-medium text-[#212B36] hover:bg-opacity-90"
          >
            Cancelar traslado
          </button>
        )}
      </div>
    </FormModal>
  );
};

export default InventoryTransferCancelModal;
